import request from '@/utils/request'

export function getNoteList(params) {
  return request({
    url: '/admin/note/list',
    method: 'get',
    params
  })
}

export function getNoteDetail(id) {
  return request({
    url: '/admin/note/' + id,
    method: 'get'
  })
}

export function updateNote(data) {
  return request({
    url: '/admin/note',
    method: 'put',
    data
  })
}

export function deleteNote(id) {
  return request({
    url: '/admin/note/' + id,
    method: 'delete'
  })
}

export function getNoteTakeRecords(id, params) {
  return request({
    url: '/admin/note/' + id + '/takes',
    method: 'get',
    params
  })
}

export function approveNote(data) {
  return request({
    url: '/admin/note/approve',
    method: 'post',
    data
  })
}

export function rejectNote(data) {
  return request({
    url: '/admin/note/reject',
    method: 'post',
    data
  })
}
